import React from 'react';
import { Image, StyleSheet, View, } from 'react-native';
import Text from 'design-system/Text';
import ToastModal from 'design-system/ToastModal';
import { rem } from 'design-system/values';
import { HEADER_WITH_SUBTITLE_HEIGHT } from 'navigators/styles';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { isWeb } from '../../../../constants';
export const PaymentToastModal = ({ isVisible, onCloseAction, title, message, iconSource, style, }) => {
    const { width } = useAppFrameDimensions();
    return (<ToastModal isVisible={isVisible} style={[staticStyles.modalStyle, style, { width }]} onCloseAction={onCloseAction}>
      <Image source={iconSource} style={staticStyles.image}/>
      <View style={staticStyles.flex}>
        <Text Text-16 White>
          {title}
        </Text>
        <Text TextThin-14 White>
          {message}
        </Text>
      </View>
    </ToastModal>);
};
const HEADER_HEIGHT = isWeb ? 64 : HEADER_WITH_SUBTITLE_HEIGHT;
const staticStyles = StyleSheet.create({
    flex: {
        flex: 1,
    },
    image: {
        width: rem(44),
        marginRight: rem(16),
    },
    modalStyle: {
        marginTop: HEADER_HEIGHT,
        alignSelf: 'center',
    },
});
export default PaymentToastModal;
